import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

/**
 * Banner zur Warnung im Entwicklungsmodus.
 * Zeigt einen auffälligen Hinweis mit konfigurierbarem Label.
 */
@Component({
  selector: 'wd-dev-warning-banner',
  standalone: true,
  imports: [CommonModule],
  template: `
    @if (isDevelopment) {
      <div class="dev-warning-banner">
        <i class="bi bi-exclamation-triangle-fill"></i>
        ENTWICKLUNGSMODUS - {{ label }}
      </div>
    }
  `,
  styles: [`
    .dev-warning-banner {
      background: linear-gradient(90deg, #ff6b35, #f7931e);
      color: white;
      text-align: center;
      padding: 6px 12px;
      font-size: 13px;
      font-weight: 600;
      letter-spacing: 0.5px;
    }
  `]
})
export class WdDevWarningBannerComponent {
  @Input() isDevelopment = false;
  @Input() label = '';
}
